/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: sitecatalyst.js
 */
(function ($, scsHeader, debug) {
	'use strict';

	$.namespace('scsHeader.siteCatalyst');

	// tzhkobj1: set timeout to 0 since Sitecatalyst already provides a 500ms delay
	scsHeader.siteCatalyst.PAGE_LOAD_DELAY = 0;

	/**
	 * Resolve referenced/shortened SiteCatalyst prop/eVar values, e.g. D=c1,
	 * where cXX stands for props and vXX for eVars
	 * @param value the concrete prop value to resolve
	 */
	scsHeader.siteCatalyst.resolveShortenedValue = function (value) {
		var regExpValue = /.*D=([c|v])(\d{1,3})$/,
			/* jshint camelcase: false */
			siteCatalyst = window.s || window.s_one;

		if (siteCatalyst && typeof value !== 'undefined' && regExpValue.test(value)) {
			var matches = regExpValue.exec(value),
				prefix = matches[1] === 'c' ? 'prop' : 'eVar',
				result = siteCatalyst[prefix + matches[2]];

			if (regExpValue.test(result)) {
				// multi-layer reference, recursion
				return scsHeader.siteCatalyst.resolveShortenedValue(result);
			} else {
				debug.log('>> resolve shortened value', value, result);
				return result;
			}
		} else {
			return value;
		}
	};

	scsHeader.siteCatalyst.trackClick = function track(me, e, link, area) {
		if(!SCS.portal || !SCS.portal.datalayer) {
			return
		}
		var $this = $(me);
		if ($this.is('.active')) {
			return;
		}

		SCS.portal.datalayer.trackEvent('link', scsHeader.siteCatalyst.resolveShortenedValue(link), 'header', area);

		// prevent double tracking of links in header
		e.stopPropagation();

		if (e.isDefaultPrevented()) {
			return;
		}

		e.preventDefault();
		var destination = $this.attr('href');
		var target = $this.attr('target') || '_self';
		var isNewTab = e.ctrlKey || e.metaKey;

		//maybe needs to be delayed by 100-200ms (google tracking experience)
		setTimeout(function () {
			if (isNewTab) {
				window.open(destination);
			}
			else {
				window.open(destination, target);
			}
		}, scsHeader.siteCatalyst.PAGE_LOAD_DELAY);
	};

	scsHeader.siteCatalyst.initHeaderTracking = function () {

		/**
		 * Legacy Header
		 */
		// TODO: Remove when old header isn’t used anymore
		$('#scs-pageheader-language-switch a').on('click', function (e) {
			scsHeader.siteCatalyst.trackClick(this, e, $(this).data('trackingLinkName'), 'Toolbar');
		});

		$('#scs-pageheader-topnav a').on('click', function (e) {
			scsHeader.siteCatalyst.trackClick(this, e, $(this).data('trackingTitle'), 'MDD');
		});

		/**
		 * Legacy L0
		 */
		// TODO: Change selector when L0 is new header
		$('#scs-pageheader-toolsnav a, #scs-pageheader-metanav a, #scs-pageheader-branchnav a').on('click', function (e) {
			scsHeader.siteCatalyst.trackClick(this, e, $(this).data('trackingLinkName'), 'Toolbar');
		});

		// Track burger click
		$('ul.scsh-icon-menu li.burger a').on('click', function (e) {
			scsHeader.siteCatalyst.trackClick(this, e, 'Burger', 'Burger-Menu');
		});
		// Track burger menu lvl-0 clicks
		$('.scsh-menu-wrapper ul.menu-items li.scsh-metanav-item a, .scsh-menu-wrapper ul.menu-items li.scsh-toolsnav-item a, .scsh-menu-wrapper ul.menu-items li.scsh-branchnav-item a').on('click', function (e) {
			scsHeader.siteCatalyst.trackClick(this, e, $(this).data('trackingLinkName') || $(this).text(), 'Burger-Menu');
		});

		/**
		 * New Header
		 */
		$('.scsh-js-language-switch a, .scsh-metanav-links a').on('click', function (e) {
			var isSticky = !!$(this).parents('.scsh-dynamic.is-sticky').length;
			scsHeader.siteCatalyst.trackClick(this, e, $(this).data('trackingLinkName') || $(this).text(), 'Toolbar' + (isSticky ? '-sticky' : ''));
		});

		// Level2
		$('.scsh-lvl2-navi li a').on('click', function (e) {
			scsHeader.siteCatalyst.trackClick(this, e, $(this).data('tracking-link-name') || $(this).find('h3').text(), 'Level2');
		});

		// search/basket icons
		$('.top-navigation li.modSiteSearch a, .top-navigation li.modFusionSearch a, .top-navigation div.modBasket a').on('click', function (e) {
			var isSticky = !!$(this).parents('.scsh-dynamic.is-sticky').length;
			scsHeader.siteCatalyst.trackClick(this, e, $(this).data('tracking-link-name'), 'MDD' + (isSticky ? '-sticky' : ''));
		});

		// logo
		$('.scsh-lvl1-container a.logo').on('click', function (e) {
			var isSticky = !!$(this).parents('.scsh-dynamic.is-sticky').length;
			scsHeader.siteCatalyst.trackClick(this, e, 'logo', 'MDD' + (isSticky ? '-sticky' : ''));
		});

	};

	// TODO remove is-mobile check when deleting old header
	$(function () {
		var $body = $(document.body);
		if ($body.hasClass('cq_isEditMode')) {
			return;
		}
		if (!$body.hasClass('is-mobile') || $body.hasClass('responsiveHeader')) {
			scsHeader.siteCatalyst.initHeaderTracking();
		}
	});
}(window.scsHeaderJQuery, window.scsHeader = window.scsHeader || {}, window.debug));



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/sitecatalyst.js
// module id = 367
// module chunks = 0